module.exports = __webpack_public_path__ + "img/icon_focus_check.1bb8199f.svg";